import { createHaper } from 'haper';
import { session } from './session';
import { ApiError } from './ApiError';

export interface ApiResponse<T = any> {
    detail?: string;
    title?: string;
    status: number;
    result: T;
    errors?: Record<string, string[]>
}


export const MOCKED_BACKEND_URL = process.env.MOCKED_BACKEND_URL;
export const API_BASE = MOCKED_BACKEND_URL || window.appConfig.API_URL;

export const haper = createHaper({
    baseUrl: API_BASE,
});

haper.registerRequestInterceptor('* * *', (request: Request) => {
    if (!session.isAuthenticated()) return;

    request.headers.append('Authorization', `Bearer ${session.data?.token}`);
});

haper.registerResponseDataInterceptor('* * *', (apiResponse: ApiResponse) => {
    if (apiResponse.status >= 400) {
        throw new ApiError({
            message: apiResponse.detail || apiResponse.title,
            errors: apiResponse.errors,
            code: apiResponse.status
        });
    }

    return apiResponse.result;
});
